import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    Lookup,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {AllowedPageSizes} from '../../../../../const/constants';
const WMTransactionDetailSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
  
    const gridKey = "71F5EC90-E935-478C-9DDC-A8AECA07982C";
     const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <Scrolling mode="virtual" />
                <Column dataField="itemCode" caption='Item' dataType="string"></Column>
                <Column dataField="itemDescription" caption='Item Description-1' dataType="string"></Column>
                <Column dataField="itemDescription2" caption='Item Description-2' visible={false} dataType="string"></Column>
                <Column dataField="lotCode" caption='Lot' dataType="string"></Column>
                <Column dataField="lotDescription" caption='Lot Description-1' dataType="string"></Column>
                <Column dataField="lotDescription2" caption='Lot Description-2' dataType="string"></Column>
                <Column dataField="inventoryUOMFlag" caption='Trans Unit' dataType="string">
                    <Lookup
                        dataSource={[
                            { ID: "I", Text: "Inventory Units" },
                            { ID: "P", Text: "Pieces" },
                            { ID: "K", Text: "Packages" },
                            { ID: "N", Text: "Shipments" }
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="quantityInventoryUOM" caption='UOM' dataType="string"></Column>
                <Column dataField="quantityOrder" caption='Ordered' format="#,##0.00" dataType="number"></Column>
                <Column dataField="quantityActual" caption='Actual' format="#,##0.00" dataType="number"></Column>
                <Column dataField="amount" caption='Amount' format="$#,##0.00" dataType="number"></Column>
                <Column dataField="classCode" caption='Class' visible={false} dataType="string"></Column>
                <Column dataField="subClassCode" caption='Sub Class' visible={false} dataType="string"></Column>
                <Column dataField="status" caption="Status" dataType="string" visible={false}>
                    <Lookup
                        dataSource={[
                            { ID: "A", Text: "Active" },
                            { ID: "I", Text: "InActive" }
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="recordNumber" caption="Record Number" dataType="string" visible={false}></Column>
                <Column dataField="dateIntroduced" caption="Introduced" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="dateAvailable" caption="Available" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="dateExpiration" caption="Expiration" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="scheduleCode" caption="Rate Shedule" dataType="string" visible={false}></Column>
                <Column dataField="storageBillingStartDate" caption="Start St. Bill" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="storageBillingEndDate" caption="End St. Bill" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="creationDateTime" caption="Creation Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="creationUserId" caption="Created By" dataType="string" visible={false}></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Updated" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="lastUpdateUserId" caption="Last Updated By" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode1" caption="Code 1" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode2" caption="Code 2" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode3" caption="Code 3" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode4" caption="Code 4" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode5" caption="Code 5" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode6" caption="Code 6" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode7" caption="Code 7" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode8" caption="Code 8" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode9" caption="Code 9" dataType="string" visible={false}></Column>
                <Column dataField="userDefinedCode10" caption="Code 10" dataType="string" visible={false}></Column>
                <Column dataField="netWeightQty" caption="Net Weight" format="#,##0.00" dataType="number" visible={false}></Column>
                <Column dataField="grossWeightQty" caption="Gross Weight" format="#,##0.00" dataType="number" visible={false}></Column>
                <Column dataField="actualPieces" caption="Actual Pieces" format="#,##0.00" dataType="number" visible={false}></Column>
                <Column dataField="actualPackage" caption="Actual Packages" format="#,##0.00" dataType="number" visible={false}></Column>
                <Column dataField="actualWeight" caption="Actual Weight" format="#,##0.00" dataType="number" visible={false}></Column>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(WMTransactionDetailSubTab);